export default [
  {
    path: "/portfolio",
    name: "portifolio",
    component: () => import("@/views/PortfolioView.vue"),
    meta: { 
      layout: "DefaultLayout",
      title: "Portfólio"
    }
  }
];
